'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactWidgets = require('react-widgets');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _commons = require('../utils/commons');

var commons = _interopRequireWildcard(_commons);

var _i18n = require('../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./reactWidgetsInit");

// TODO PropTypes
/**
 * Input pro datumy.
 * Nutné speciálně řešit onBlur, protože react widgets ho nepodporují.
 */
var TimeField = function (_AbstractField) {
    (0, _inherits3.default)(TimeField, _AbstractField);

    function TimeField(props) {
        (0, _classCallCheck3.default)(this, TimeField);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TimeField.__proto__ || (0, _getPrototypeOf2.default)(TimeField)).call(this, props));

        _this.getValueFromProps = function (value) {
            return value && value != "" ? commons.localUTCToTime(value) : null;
        };

        _this.getValueForReturn = function (value) {
            return value && value != "" ? commons.timeToLocalUTC(value) : null;
        };

        _this.handleChange = function (value, text) {
            var onChange = _this.props.onChange;


            _this.setState({
                value: value
            });

            onChange(_this.getValueForReturn(value));
        };

        _this.handleBlur = function () {
            var onBlur = _this.props.onBlur;
            var value = _this.state.value;

            onBlur && onBlur(_this.getValueForReturn(value));
        };

        _this.state = {
            value: _this.getValueFromProps(props.value)
        };
        return _this;
    }

    /**
     * Konverze hodnoty z props na editovanou hodnotu.
     * @param value props hodnota
     * @return {null} hodnota, kterou potřebuje field pro editaci
     */


    /**
     * Konverze editované hodnoty pro poslání ven.
     * @param value editovaná hodnota
     * @return {null} hodnota pro odeslání ven
     */


    (0, _createClass3.default)(TimeField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: this.getValueFromProps(nextProps.value)
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var picker = _reactDom2.default.findDOMNode(this.refs.picker);
            picker.children[0].className += " form-control";
            picker.children[1].className += " input-group-btn";
            picker.children[1].children[0].className += " btn btn-secondary";
            picker.children[1].children[0].removeAttribute("tabindex");
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                value = _props.value,
                className = _props.className,
                onChange = _props.onChange,
                onBlur = _props.onBlur,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'value', 'className', 'onChange', 'onBlur']);


            var objValue = this.getValueFromProps(value);

            var cls = (0, _classnames2.default)("input-group", className);

            var field = _react2.default.createElement(_reactWidgets.DateTimePicker, (0, _extends3.default)({
                ref: 'picker',
                time: true,
                className: cls,
                calendar: false,
                value: objValue,
                onBlur: this.handleBlur,
                onChange: this.handleChange,
                messages: { timeButton: (0, _i18n2.default)('dateTimePicker.timeButton') }
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return TimeField;
}(_AbstractField3.default);

exports.default = TimeField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvVGltZUZpZWxkLmpzeCJdLCJuYW1lcyI6WyJjb21tb25zIiwicmVxdWlyZSIsIlRpbWVGaWVsZCIsInByb3BzIiwiZ2V0VmFsdWVGcm9tUHJvcHMiLCJ2YWx1ZSIsImxvY2FsVVRDVG9UaW1lIiwiZ2V0VmFsdWVGb3JSZXR1cm4iLCJ0aW1lVG9Mb2NhbFVUQyIsImhhbmRsZUNoYW5nZSIsInRleHQiLCJvbkNoYW5nZSIsInNldFN0YXRlIiwiaGFuZGxlQmx1ciIsIm9uQmx1ciIsInN0YXRlIiwibmV4dFByb3BzIiwicGlja2VyIiwiUmVhY3RET00iLCJmaW5kRE9NTm9kZSIsInJlZnMiLCJjaGlsZHJlbiIsImNsYXNzTmFtZSIsInJlbW92ZUF0dHJpYnV0ZSIsImFkZG9uc0JlZm9yZSIsImFkZG9uc0FmdGVyIiwib2JqVmFsdWUiLCJjbHMiLCJmaWVsZCIsInRpbWVCdXR0b24iLCJyZW5kZXJGaWVsZFdpdGhBZGRvbnMiLCJBYnN0cmFjdEZpZWxkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7SUFBWUEsTzs7QUFFWjs7Ozs7Ozs7QUFEQUMsUUFBUSxvQkFBUjs7QUFHQTtBQUNBOzs7O0lBSU1DLFM7OztBQUNGLHVCQUFZQyxLQUFaLEVBQW1CO0FBQUE7O0FBQUEsZ0pBQ1RBLEtBRFM7O0FBQUEsY0FhbkJDLGlCQWJtQixHQWFDLFVBQUNDLEtBQUQsRUFBVztBQUMzQixtQkFBUUEsU0FBU0EsU0FBUyxFQUFuQixHQUF5QkwsUUFBUU0sY0FBUixDQUF1QkQsS0FBdkIsQ0FBekIsR0FBeUQsSUFBaEU7QUFDSCxTQWZrQjs7QUFBQSxjQXNCbkJFLGlCQXRCbUIsR0FzQkMsVUFBQ0YsS0FBRCxFQUFXO0FBQzNCLG1CQUFRQSxTQUFTQSxTQUFTLEVBQW5CLEdBQXlCTCxRQUFRUSxjQUFSLENBQXVCSCxLQUF2QixDQUF6QixHQUF5RCxJQUFoRTtBQUNILFNBeEJrQjs7QUFBQSxjQXdDbkJJLFlBeENtQixHQXdDSixVQUFDSixLQUFELEVBQVFLLElBQVIsRUFBaUI7QUFBQSxnQkFDckJDLFFBRHFCLEdBQ1QsTUFBS1IsS0FESSxDQUNyQlEsUUFEcUI7OztBQUc1QixrQkFBS0MsUUFBTCxDQUFjO0FBQ1ZQLHVCQUFPQTtBQURHLGFBQWQ7O0FBSUFNLHFCQUFTLE1BQUtKLGlCQUFMLENBQXVCRixLQUF2QixDQUFUO0FBQ0gsU0FoRGtCOztBQUFBLGNBa0RuQlEsVUFsRG1CLEdBa0ROLFlBQU07QUFBQSxnQkFDUkMsTUFEUSxHQUNFLE1BQUtYLEtBRFAsQ0FDUlcsTUFEUTtBQUFBLGdCQUVSVCxLQUZRLEdBRUMsTUFBS1UsS0FGTixDQUVSVixLQUZROztBQUdmUyxzQkFBVUEsT0FBTyxNQUFLUCxpQkFBTCxDQUF1QkYsS0FBdkIsQ0FBUCxDQUFWO0FBQ0gsU0F0RGtCOztBQUdmLGNBQUtVLEtBQUwsR0FBYTtBQUNUVixtQkFBTyxNQUFLRCxpQkFBTCxDQUF1QkQsTUFBTUUsS0FBN0I7QUFERSxTQUFiO0FBSGU7QUFNbEI7O0FBRUQ7Ozs7Ozs7QUFTQTs7Ozs7Ozs7O2tEQVMwQlcsUyxFQUFXO0FBQ2pDLGlCQUFLSixRQUFMLENBQWM7QUFDVlAsdUJBQU8sS0FBS0QsaUJBQUwsQ0FBdUJZLFVBQVVYLEtBQWpDO0FBREcsYUFBZDtBQUdIOzs7NENBRW1CO0FBQ2hCLGdCQUFNWSxTQUFTQyxtQkFBU0MsV0FBVCxDQUFxQixLQUFLQyxJQUFMLENBQVVILE1BQS9CLENBQWY7QUFDQUEsbUJBQU9JLFFBQVAsQ0FBZ0IsQ0FBaEIsRUFBbUJDLFNBQW5CLElBQWdDLGVBQWhDO0FBQ0FMLG1CQUFPSSxRQUFQLENBQWdCLENBQWhCLEVBQW1CQyxTQUFuQixJQUFnQyxrQkFBaEM7QUFDQUwsbUJBQU9JLFFBQVAsQ0FBZ0IsQ0FBaEIsRUFBbUJBLFFBQW5CLENBQTRCLENBQTVCLEVBQStCQyxTQUEvQixJQUE0QyxvQkFBNUM7QUFDQUwsbUJBQU9JLFFBQVAsQ0FBZ0IsQ0FBaEIsRUFBbUJBLFFBQW5CLENBQTRCLENBQTVCLEVBQStCRSxlQUEvQixDQUErQyxVQUEvQztBQUNIOzs7aUNBa0JRO0FBQUEseUJBQzZFLEtBQUtwQixLQURsRjtBQUFBLGdCQUNFcUIsWUFERixVQUNFQSxZQURGO0FBQUEsZ0JBQ2dCQyxXQURoQixVQUNnQkEsV0FEaEI7QUFBQSxnQkFDNkJwQixLQUQ3QixVQUM2QkEsS0FEN0I7QUFBQSxnQkFDb0NpQixTQURwQyxVQUNvQ0EsU0FEcEM7QUFBQSxnQkFDK0NYLFFBRC9DLFVBQytDQSxRQUQvQztBQUFBLGdCQUN5REcsTUFEekQsVUFDeURBLE1BRHpEO0FBQUEsZ0JBQ29FWCxLQURwRTs7O0FBR0wsZ0JBQU11QixXQUFXLEtBQUt0QixpQkFBTCxDQUF1QkMsS0FBdkIsQ0FBakI7O0FBRUEsZ0JBQU1zQixNQUFNLDBCQUNSLGFBRFEsRUFFUkwsU0FGUSxDQUFaOztBQUtBLGdCQUFNTSxRQUFRLDhCQUFDLDRCQUFEO0FBQ1YscUJBQUksUUFETTtBQUVWLHNCQUFNLElBRkk7QUFHViwyQkFBV0QsR0FIRDtBQUlWLDBCQUFVLEtBSkE7QUFLVix1QkFBT0QsUUFMRztBQU1WLHdCQUFRLEtBQUtiLFVBTkg7QUFPViwwQkFBVSxLQUFLSixZQVBMO0FBUVYsMEJBQVUsRUFBQ29CLFlBQVksb0JBQUssMkJBQUwsQ0FBYjtBQVJBLGVBU04xQixLQVRNLEVBQWQ7O0FBWUEsbUJBQU8sS0FBSzJCLHFCQUFMLENBQTJCRixLQUEzQixFQUFrQ0osWUFBbEMsRUFBZ0RDLFdBQWhELENBQVA7QUFDSDs7O0VBaEZtQk0sdUI7O2tCQWtGVDdCLFMiLCJmaWxlIjoiVGltZUZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUmVhY3RET00gZnJvbSAncmVhY3QtZG9tJztcbmltcG9ydCB7RGF0ZVRpbWVQaWNrZXJ9IGZyb20gXCJyZWFjdC13aWRnZXRzXCI7XG5pbXBvcnQgQWJzdHJhY3RGaWVsZCBmcm9tIFwiLi9BYnN0cmFjdEZpZWxkXCI7XG5pbXBvcnQgY2xhc3NOYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCAqIGFzIGNvbW1vbnMgZnJvbSAnLi4vdXRpbHMvY29tbW9ucydcbnJlcXVpcmUoXCIuL3JlYWN0V2lkZ2V0c0luaXRcIik7XG5pbXBvcnQgaTE4biBmcm9tICcuLi9pMThuL2kxOG4nO1xuXG4vLyBUT0RPIFByb3BUeXBlc1xuLyoqXG4gKiBJbnB1dCBwcm8gZGF0dW15LlxuICogTnV0bsOpIHNwZWNpw6FsbsSbIMWZZcWhaXQgb25CbHVyLCBwcm90b8W+ZSByZWFjdCB3aWRnZXRzIGhvIG5lcG9kcG9ydWrDrS5cbiAqL1xuY2xhc3MgVGltZUZpZWxkIGV4dGVuZHMgQWJzdHJhY3RGaWVsZCB7XG4gICAgY29uc3RydWN0b3IocHJvcHMpIHtcbiAgICAgICAgc3VwZXIocHJvcHMpO1xuXG4gICAgICAgIHRoaXMuc3RhdGUgPSB7XG4gICAgICAgICAgICB2YWx1ZTogdGhpcy5nZXRWYWx1ZUZyb21Qcm9wcyhwcm9wcy52YWx1ZSlcbiAgICAgICAgfVxuICAgIH1cblxuICAgIC8qKlxuICAgICAqIEtvbnZlcnplIGhvZG5vdHkgeiBwcm9wcyBuYSBlZGl0b3Zhbm91IGhvZG5vdHUuXG4gICAgICogQHBhcmFtIHZhbHVlIHByb3BzIGhvZG5vdGFcbiAgICAgKiBAcmV0dXJuIHtudWxsfSBob2Rub3RhLCBrdGVyb3UgcG90xZllYnVqZSBmaWVsZCBwcm8gZWRpdGFjaVxuICAgICAqL1xuICAgIGdldFZhbHVlRnJvbVByb3BzID0gKHZhbHVlKSA9PiB7XG4gICAgICAgIHJldHVybiAodmFsdWUgJiYgdmFsdWUgIT0gXCJcIikgPyBjb21tb25zLmxvY2FsVVRDVG9UaW1lKHZhbHVlKSA6IG51bGw7XG4gICAgfTtcblxuICAgIC8qKlxuICAgICAqIEtvbnZlcnplIGVkaXRvdmFuw6kgaG9kbm90eSBwcm8gcG9zbMOhbsOtIHZlbi5cbiAgICAgKiBAcGFyYW0gdmFsdWUgZWRpdG92YW7DoSBob2Rub3RhXG4gICAgICogQHJldHVybiB7bnVsbH0gaG9kbm90YSBwcm8gb2Rlc2zDoW7DrSB2ZW5cbiAgICAgKi9cbiAgICBnZXRWYWx1ZUZvclJldHVybiA9ICh2YWx1ZSkgPT4ge1xuICAgICAgICByZXR1cm4gKHZhbHVlICYmIHZhbHVlICE9IFwiXCIpID8gY29tbW9ucy50aW1lVG9Mb2NhbFVUQyh2YWx1ZSkgOiBudWxsO1xuICAgIH07XG5cbiAgICBjb21wb25lbnRXaWxsUmVjZWl2ZVByb3BzKG5leHRQcm9wcykge1xuICAgICAgICB0aGlzLnNldFN0YXRlKHtcbiAgICAgICAgICAgIHZhbHVlOiB0aGlzLmdldFZhbHVlRnJvbVByb3BzKG5leHRQcm9wcy52YWx1ZSlcbiAgICAgICAgfSlcbiAgICB9XG5cbiAgICBjb21wb25lbnREaWRNb3VudCgpIHtcbiAgICAgICAgY29uc3QgcGlja2VyID0gUmVhY3RET00uZmluZERPTU5vZGUodGhpcy5yZWZzLnBpY2tlcik7XG4gICAgICAgIHBpY2tlci5jaGlsZHJlblswXS5jbGFzc05hbWUgKz0gXCIgZm9ybS1jb250cm9sXCI7XG4gICAgICAgIHBpY2tlci5jaGlsZHJlblsxXS5jbGFzc05hbWUgKz0gXCIgaW5wdXQtZ3JvdXAtYnRuXCI7XG4gICAgICAgIHBpY2tlci5jaGlsZHJlblsxXS5jaGlsZHJlblswXS5jbGFzc05hbWUgKz0gXCIgYnRuIGJ0bi1zZWNvbmRhcnlcIjtcbiAgICAgICAgcGlja2VyLmNoaWxkcmVuWzFdLmNoaWxkcmVuWzBdLnJlbW92ZUF0dHJpYnV0ZShcInRhYmluZGV4XCIpO1xuICAgIH1cblxuICAgIGhhbmRsZUNoYW5nZSA9ICh2YWx1ZSwgdGV4dCkgPT4ge1xuICAgICAgICBjb25zdCB7b25DaGFuZ2V9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICB0aGlzLnNldFN0YXRlKHtcbiAgICAgICAgICAgIHZhbHVlOiB2YWx1ZVxuICAgICAgICB9KVxuXG4gICAgICAgIG9uQ2hhbmdlKHRoaXMuZ2V0VmFsdWVGb3JSZXR1cm4odmFsdWUpKTtcbiAgICB9XG5cbiAgICBoYW5kbGVCbHVyID0gKCkgPT4ge1xuICAgICAgICBjb25zdCB7b25CbHVyfSA9IHRoaXMucHJvcHM7XG4gICAgICAgIGNvbnN0IHt2YWx1ZX0gPSB0aGlzLnN0YXRlO1xuICAgICAgICBvbkJsdXIgJiYgb25CbHVyKHRoaXMuZ2V0VmFsdWVGb3JSZXR1cm4odmFsdWUpKTtcbiAgICB9O1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICBjb25zdCB7YWRkb25zQmVmb3JlLCBhZGRvbnNBZnRlciwgdmFsdWUsIGNsYXNzTmFtZSwgb25DaGFuZ2UsIG9uQmx1ciwgLi4ucHJvcHN9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICBjb25zdCBvYmpWYWx1ZSA9IHRoaXMuZ2V0VmFsdWVGcm9tUHJvcHModmFsdWUpO1xuXG4gICAgICAgIGNvbnN0IGNscyA9IGNsYXNzTmFtZXMoXG4gICAgICAgICAgICBcImlucHV0LWdyb3VwXCIsXG4gICAgICAgICAgICBjbGFzc05hbWVcbiAgICAgICAgKTtcblxuICAgICAgICBjb25zdCBmaWVsZCA9IDxEYXRlVGltZVBpY2tlclxuICAgICAgICAgICAgcmVmPVwicGlja2VyXCJcbiAgICAgICAgICAgIHRpbWU9e3RydWV9XG4gICAgICAgICAgICBjbGFzc05hbWU9e2Nsc31cbiAgICAgICAgICAgIGNhbGVuZGFyPXtmYWxzZX1cbiAgICAgICAgICAgIHZhbHVlPXtvYmpWYWx1ZX1cbiAgICAgICAgICAgIG9uQmx1cj17dGhpcy5oYW5kbGVCbHVyfVxuICAgICAgICAgICAgb25DaGFuZ2U9e3RoaXMuaGFuZGxlQ2hhbmdlfVxuICAgICAgICAgICAgbWVzc2FnZXM9e3t0aW1lQnV0dG9uOiBpMThuKCdkYXRlVGltZVBpY2tlci50aW1lQnV0dG9uJyl9fVxuICAgICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAvPjtcblxuICAgICAgICByZXR1cm4gdGhpcy5yZW5kZXJGaWVsZFdpdGhBZGRvbnMoZmllbGQsIGFkZG9uc0JlZm9yZSwgYWRkb25zQWZ0ZXIpO1xuICAgIH1cbn1cbmV4cG9ydCBkZWZhdWx0IFRpbWVGaWVsZDtcbiJdfQ==